import { Fragment, Slice, type Node } from '@tiptap/pm/model';

function isEmptyListItem(node: Node): boolean {
  if (node.type.name !== 'listItem') {
    return false;
  }
  if (
    node.textContent
      .replace(/\u00a0/g, ' ')
      .replace(/\u200B/g, '')
      .replace(/\uFEFF/g, '')
      .trim().length > 0
  ) {
    return false;
  }
  let hasMedia = false;
  node.descendants(child => {
    if (child.type.name === 'image') {
      hasMedia = true;
    }
    if (child.isText && child.marks.some(mark => mark.type.name === 'link')) {
      hasMedia = true;
    }
  });
  return !hasMedia;
}

function mapFragment(
  fragment: Fragment,
  mapNode: (node: Node) => Node | null,
): Fragment {
  const children: Node[] = [];
  fragment.forEach(node => {
    const mapped = mapNode(node);
    if (!mapped) {
      return;
    }
    if (mapped.content.size > 0) {
      const inner = mapFragment(mapped.content, mapNode);
      if (
        inner.size === 0 &&
        (mapped.type.name === 'bulletList' ||
          mapped.type.name === 'orderedList')
      ) {
        return;
      }
      children.push(mapped.copy(inner));
      return;
    }
    children.push(mapped);
  });
  return Fragment.fromArray(children);
}

/** Remove empty listItem nodes TipTap creates when email paste splits one list across multiple `<ul>` blocks. */
export function stripEmptyListItemsFromSlice(slice: Slice): Slice {
  const content = mapFragment(slice.content, node =>
    isEmptyListItem(node) ? null : node,
  );
  return new Slice(content, slice.openStart, slice.openEnd);
}
